import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { map, Observable } from "rxjs";
import { MaintenanceService } from "../../services/maintenance.service";

interface MaintenanceAlert {
  isActive: boolean;
  message: string;
}

@Component({
  selector: "brd-maintenance-alert",
  templateUrl: "./maintenance-alert.component.html",
  styleUrl: "./maintenance-alert.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  providers: [DatePipe]
})
export class MaintenanceAlertComponent {
  maintenance$: Observable<MaintenanceAlert> = this.maintenanceService.maintenance$.pipe(
    map(x => {
      if (!x.id) return { isActive: false, message: "" } as MaintenanceAlert;

      const startDate = new Date(x.startDate!);
      const endDate = new Date(x.endDate!);

      const message =
        startDate.getDay() === endDate.getDay()
          ? `<strong>MAINTENANCE WINDOW SCHEDULED</strong> for <strong>${this.datePipe.transform(startDate, "MM.dd.yyyy")}</strong> from <strong>${this.datePipe.transform(startDate, "HH:mm")}</strong> to <strong>${this.datePipe.transform(endDate, "HH:mm")}</strong> <small>(Already adjusted in your local timezone.)</small>`
          : `<strong>MAINTENANCE WINDOW SCHEDULED</strong> from <strong>${this.datePipe.transform(startDate, "MM.dd.yyyy 'h' HH:mm")}</strong> to <strong>${this.datePipe.transform(endDate, "MM.dd.yyyy 'h' HH:mm")}</strong> <small>(Already adjusted in your local timezone.)</small>`;

      return {
        isActive: x.isActive,
        message: message
      } as MaintenanceAlert;
    })
  );
  constructor(
    private readonly maintenanceService: MaintenanceService,
    private datePipe: DatePipe
  ) {}
}
